import { Box, CircularProgress } from "@mui/joy";
import { Typography } from "@mui/joy";

const LargeLoader = ({ text }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: "center", minHeight: "70vh", width: "100%", justifyContent: 'center', p: 4, flexDirection: 'column' }}>
      <CircularProgress size='lg' />
      {text &&
        <Typography level='h4' sx={{ mt: 4 }}>
          {text}
        </Typography>
      }
    </Box>
  );
}

export default LargeLoader;